// Module
var code = `<div class="instrument-lookup-component-main" style="{{>position}}">
    <div class="instrument-lookup-component">
        <div class="buttons-bar">
            <terceraButton name="add" SVG="true" terceraButtonStyle="image-button-plain" on-btnClick="openInstrumentLookup"/>
            <terceraTextBox additionalClass="instrument-lookup-textbox" text="{{.searchText}}"/>
        </div>
        <div class="body_instruments_lookupDropDownForm">
            <terceraQuickTree  name="quickTreeRactive" boldRootNode="true" 
            on-selection="instrumentSelection"
            on-afterMouseDown="quickTreeAfterMouseDown"/>
        </div>
    </div>
</div>`;
// Exports
export default code;